interface DashboardEntity {
  title: string
  dashboardUrl: string
  message?: string
  type: EntityType
}

type EntityType =
  | 'article'
  | 'page'
  | 'homePage'
  | 'schedule'
  | 'rosterPlayer'
  | 'roster'
  | 'rosterStaff'
  | 'team'

export const useCurrentEntity = () => useState<DashboardEntity | undefined>('current-dashboard-entity')
